import React from 'react'
import clsx from 'clsx'

// Radius 12, 1px --line, white fill, 20px of padding (24 from 960px up), no
// shadow at rest. Hover darkens the border to --ink, and only on a pointer
// device, so a phone tap does not leave a card looking selected.
//
// Give it `href` and the whole card becomes one link (what the three wash
// cards on the fold need); give it `onClick` without `href` and it becomes a
// button. `selected` is the booking screen's chosen state: 2px --accent
// border on --accent-soft.
//
//   <Card href="/booking/book?service=mini_valet">...</Card>
//   <Card as="li">...</Card>
export const Card = ({ as: Tag = 'div', href, onClick, selected = false, className, children, ...rest }) => {
  const interactive = Boolean(href || onClick)
  const classes = clsx(
    'gwmc-card',
    interactive && 'gwmc-card--link',
    selected && 'gwmc-card--selected',
    className
  )

  if (href) {
    return (
      <a className={classes} href={href} onClick={onClick} {...rest}>
        {children}
      </a>
    )
  }

  if (onClick) {
    return (
      <button type="button" className={classes} onClick={onClick} {...rest}>
        {children}
      </button>
    )
  }

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  )
}
